import { Font } from "@react-pdf/renderer";

// Static weight-specific font files for @react-pdf/renderer.
// Variable fonts don't render correct weights in @react-pdf v2.x,
// so we use separate Bold (700) and ExtraBold (800) WOFF files
// downloaded from Google Fonts CDN.
import LeagueSpartanBold from "./LeagueSpartan-Bold.woff";
import LeagueSpartanExtraBold from "./LeagueSpartan-ExtraBold.woff";

Font.register({
  family: "spartanFont",
  fonts: [
    {
      src: LeagueSpartanBold,
      fontWeight: 700,
    },
    {
      src: LeagueSpartanExtraBold,
      fontWeight: 800,
    },
  ],
});
